import React, { useState } from 'react'

export default function RegisterStep({ email, loading, error, onSubmit, onBack }) {
  const [name, setName] = useState('')
  const [localError, setLocalError] = useState('')

  function handleSubmit(e) {
    e.preventDefault()
    if (name.trim().length < 3) {
      setLocalError('Naam moet minimaal 3 karakters zijn')
      return
    }
    setLocalError('')
    onSubmit(name.trim())
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800 rounded-md p-4">
        <p className="text-sm text-green-700 dark:text-green-300">
          <strong>{email}</strong> is nog niet bekend. Vul je naam in om je aan te melden.
        </p>
      </div>
      <div>
        <label htmlFor="name" className="form-label">Naam</label>
        <input
          id="name"
          type="text"
          autoComplete="name"
          value={name}
          onChange={(e) => { setName(e.target.value); setLocalError('') }}
          className={`form-input ${(localError || error) ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : ''}`}
          placeholder="Je volledige naam"
          disabled={loading}
          autoFocus
        />
        {(localError || error) && (
          <p className="mt-1 text-sm text-red-600 dark:text-red-400">{localError || error}</p>
        )}
      </div>
      <div className="bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-800 rounded-md p-3">
        <p className="text-sm text-blue-700 dark:text-blue-300">
          Je email wordt alleen gebruikt voor meetup uitnodigingen. Je kunt je altijd uitschrijven.
        </p>
      </div>
      <div className="flex flex-col space-y-3">
        <button type="submit" className="btn btn-primary w-full text-lg py-3" disabled={loading}>
          {loading ? (
            <span className="flex items-center justify-center space-x-2">
              <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
              <span>Aanmelden...</span>
            </span>
          ) : 'Aanmelden'}
        </button>
        <button type="button" onClick={onBack} className="btn btn-outline w-full" disabled={loading}>
          Ander emailadres gebruiken
        </button>
      </div>
    </form>
  )
}
